import { render, staticRenderFns } from "./ModalConsolidacaoAR.vue?vue&type=template&id=5d99b941&lang=pug"
import script from "./ModalConsolidacaoAR.vue?vue&type=script&lang=js"
export * from "./ModalConsolidacaoAR.vue?vue&type=script&lang=js"
import style0 from "./ModalConsolidacaoAR.vue?vue&type=style&index=0&id=5d99b941&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports